// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .step-form-dialog .p-dialog-header {
  background: #0066B2;
  color: white;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::ng-deep .step-form-dialog .p-dialog-header .custom-dialog-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}
::ng-deep .step-form-dialog .p-dialog-header .dialog-close-btn {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
::ng-deep .step-form-dialog .p-dialog-header .dialog-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: rotate(90deg) scale(1.1);
  border-color: rgba(255, 255, 255, 0.3);
}
::ng-deep .step-form-dialog .p-dialog-header .dialog-close-btn:active {
  transform: rotate(90deg) scale(0.95);
}
::ng-deep .step-form-dialog .p-dialog-content {
  padding: 20px;
}
::ng-deep .step-form-dialog .p-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.form-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
}
.form-row .step-number-group {
  flex: 0 0 100px;
  margin-bottom: 0;
}
.form-row .checkbox-group-inline {
  margin-bottom: 0;
  padding-bottom: 4px;
}
.form-row .checkbox-group-inline label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #3a3a3a;
  white-space: nowrap;
}
.form-row .checkbox-group-inline label input[type=checkbox] {
  width: 16px;
  height: 16px;
  accent-color: #0066B2;
}

.form-group {
  margin-bottom: 16px;
}
.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #3a3a3a;
  margin-bottom: 6px;
}
.form-group label .required {
  color: #e74c3c;
}
.form-group .body-counter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 6px;
  font-size: 12px;
  color: #777;
}
.form-group .body-counter.over-limit {
  color: #e74c3c;
}
.form-group .body-counter .body-counter-warning {
  font-weight: 600;
}
.form-group .body-counter .body-counter-count {
  margin-left: auto;
  white-space: nowrap;
}
.form-group .form-input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #EFEFEF;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}
.form-group .form-input:focus {
  outline: none;
  border-color: #0066B2;
  box-shadow: 0 0 0 3px rgba(0, 102, 178, 0.1);
}
.form-group .form-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #EFEFEF;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}
.form-group .form-textarea:focus {
  outline: none;
  border-color: #0066B2;
  box-shadow: 0 0 0 3px rgba(0, 102, 178, 0.1);
}

.image-upload-area {
  border: 2px dashed #EFEFEF;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.image-upload-area:hover {
  border-color: rgba(0, 102, 178, 0.4);
}
.image-upload-area.drag-over {
  border-color: #0066B2;
  background: rgba(0, 102, 178, 0.06);
}
.image-upload-area.drag-over .upload-icon {
  color: #0066B2 !important;
}
.image-upload-area .upload-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #777;
  font-size: 13px;
}
.image-upload-area .upload-controls .upload-icon {
  font-size: 28px;
  color: rgba(0, 102, 178, 0.4);
}
.image-upload-area .upload-btn {
  display: inline-block;
  padding: 6px 16px;
  background: #0066B2;
  color: white;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
}
.image-upload-area .upload-btn:hover {
  background: #0B2D71;
}
.image-upload-area .image-preview {
  position: relative;
  display: inline-block;
  max-width: 100%;
}
.image-upload-area .image-preview img {
  max-width: 100%;
  max-height: 180px;
  border-radius: 6px;
  object-fit: contain;
  display: block;
}
.image-upload-area .image-preview .remove-image-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background 0.2s ease;
}
.image-upload-area .image-preview .remove-image-btn i {
  font-size: 10px;
}
.image-upload-area .image-preview .remove-image-btn:hover {
  background: rgba(231, 76, 60, 0.9);
}
.image-upload-area .change-btn {
  display: inline-block;
  margin-top: 10px;
  padding: 5px 14px;
  border: 1px solid rgba(0, 102, 178, 0.3);
  background: transparent;
  color: #0066B2;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.image-upload-area .change-btn:hover {
  background: rgba(0, 102, 178, 0.06);
  border-color: #0066B2;
}
.image-upload-area .file-input-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 16px;
  border-top: 1px solid #EFEFEF;
  margin-top: 8px;
}
.dialog-actions .btn-cancel {
  padding: 9px 20px;
  border: 1px solid #EFEFEF;
  background: white;
  color: #777;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.dialog-actions .btn-cancel:hover {
  border-color: #0066B2;
  color: #0066B2;
}
.dialog-actions .btn-save {
  padding: 9px 20px;
  border: none;
  background: #0066B2;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.dialog-actions .btn-save:hover:not(:disabled) {
  background: #0B2D71;
}
.dialog-actions .btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
